const mobileSection = document.querySelector('.show-on-mobile');

if (mobileSection && window.innerWidth < 768) {
  mobileSection.classList.add('show');
}
